import React, { useState } from 'react';
import { XIcon, PencilIcon, BookOpenIcon } from 'lucide-react';
type StoryPreviewProps = {
  story: string;
  onClose: () => void;
  onEdit: () => void;
  onCreate: () => void;
};
export const StoryPreview = ({
  story,
  onClose,
  onEdit,
  onCreate
}: StoryPreviewProps) => {
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50" data-id="element-992">
      <div className="bg-[#FFFAE4] rounded-2xl w-full max-w-4xl p-6 border border-[#E5C1A9]" data-id="element-993">
        <div className="flex items-center justify-between mb-6" data-id="element-994">
          <h2 className="text-xl font-bold text-[#6B4B3E]" data-id="element-995">
            Your Story Preview
          </h2>
          <button onClick={onClose} className="p-2 hover:bg-[#FFF0E6] rounded-full transition-colors" data-id="element-996">
            <XIcon size={20} className="text-[#6B4B3E]" data-id="element-997" />
          </button>
        </div>

        <div className="bg-[#FFF0E6] rounded-xl p-6 mb-6 max-h-[60vh] overflow-y-auto" data-id="element-998">
          <p className="text-lg text-[#6B4B3E] leading-relaxed whitespace-pre-wrap" data-id="element-999">
            {story}
          </p>
        </div>

        <div className="flex justify-end space-x-4" data-id="element-1000">
          <button onClick={onEdit} className="px-6 py-3 rounded-full border-2 border-[#E5C1A9] text-[#6B4B3E] hover:bg-[#FFF0E6] transition-colors flex items-center" data-id="element-1001">
            <PencilIcon size={20} className="mr-2" data-id="element-1002" />
            Edit Story
          </button>
          <button onClick={onCreate} className="px-6 py-3 bg-[#D4A088] text-white rounded-full hover:bg-[#C28B73] transition-colors flex items-center" data-id="element-1003">
            <BookOpenIcon size={20} className="mr-2" data-id="element-1004" />
            Create My Story!
          </button>
        </div>
      </div>
    </div>;
};